import { useContext } from 'react';
import { PolarisVizContext } from '../contexts/PolarisVizContext.js';

function usePolarisVizContext() {
  const context = useContext(PolarisVizContext);
  return context;
}

export { usePolarisVizContext };
